import React from 'react';


/**
 * Modal section that displays warnings to user.
 *
 * @param props.title String that contains the title of the warning box.
 * @param props.body String that contains the body text of the warning box.
 * @param props.insightMessage String that contains any additional insightful message.
 * @return JSX
 */
export function HelioviewerModalWarningBox(props) {
    const {title, body, insightMessage} = props;

    return (
      <div className="helioviewerModalWarningBox">
        <h2>{title}</h2>
        {insightMessage && <div className="helioviewerModalWarningMessageWithStatus">{insightMessage}</div>}
        <div className="helioviewerModalWarningMessageWithStatus">{body.split('|n|').map(el=>(el.slice(0,3) !== "|t|" ? <div>{el}</div> : <div>&emsp;{el.replace("|t|","")}</div>))}</div>
      </div>
    )
}

